import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductForm } from '@app/components/forms/ProductsForm/ProductsForm';

import { PageTitle } from '@app/components/common/PageTitle/PageTitle';

const AddProductPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* <PageTitle>{t('Add-Product')}</PageTitle> */}
      <PageTitle>{"JRDC-Admin"}</PageTitle>
      <ProductForm type={"create"}  editable = {true} />
    </>
  );
};

export default AddProductPage;
